'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignedVouchersSelector = exports.usableVouchersSelector = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _voucher = require('../helpers/voucher');

var _voucher2 = _interopRequireDefault(_voucher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usableVouchersSelector = exports.usableVouchersSelector = (0, _reselect.createSelector)(function (state) {
  return state.voucher;
}, function (state) {
  return state.order.cart.length;
}, function (state) {
  return _cart2.default.total(state.order.cart);
}, function (voucher, cartItemsLength, cartTotal) {
  if (!voucher || !voucher.instances) {
    return null;
  }
  return _lodash2.default.filter(voucher.instances, function (x) {
    var threshold = x.constraints.threshold || 0;
    // voucher instances filterd by modules and threshold
    if (cartItemsLength === 0) {
      return _voucher2.default.isVoucherUsable(x);
    }
    return _voucher2.default.isVoucherUsable(x) && cartTotal >= threshold;
  });
});

var assignedVouchersSelector = exports.assignedVouchersSelector = (0, _reselect.createSelector)(function (state) {
  return state.voucher;
}, function (voucher) {
  if (!voucher || !voucher.instances) {
    return null;
  }
  return voucher.instances.filter(function (x) {
    return _voucher2.default.isVoucherAssigned(x);
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/voucher.js
// module id = 117
// module chunks = 0